import ClauseOptions from "./ClauseOptions";

export default ClauseOptions;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/ClauseOptions/index.js